import { render, createRoot, createElement } from 'react-dom'
import { componentsData } from './ComponentsData'

const renderComponentToElements = ( item ) => {

    const elements = document.querySelectorAll(item.selector)
  
    for (const elem of elements) {

        const dataProps = {}
        
        if( item.data ){
            item.data.map((attr) => {
                const attrValue = elem.getAttribute(attr)
                if (attrValue !== null) dataProps[attr] = attrValue
            })
        }
    
        // Dynamically create the React component and pass the attribute as a prop
        const component = createElement(item.component, dataProps )

        // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
        createRoot ? createRoot(elem).render(component) : render(component, elem)
    }
}

export const renderFields = () => {
    
    window.addEventListener('load', () => {
        const lists = componentsData()
        lists.map((item) => {
            renderComponentToElements(item)
        })
    })
}